import React from 'react';
import styled from 'styled-components';
import { enableTabKeyDetection } from '@telia/styleguide';
import AllIcons from '@telia/styleguide/assets/allicons/AllIcons';
import { Route, Switch } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { GlobalMenu } from './modules/GlobalMenu';
import StepIndicatorBar from './modules/step-indicator/StepIndicator';
import { useAuthenticate } from './util/SalesApi';
import Personalia from './pages/personalia/Personalia';
import AddressSearch from './pages/address-search/AddressSearch';
import { headerHeight, MediaQueries, paddingMedium, paddingSmall } from './util/MediaQueries';
import SalesPackagePage from './pages/sales-package-page/SalesPackagePage';
import { routes } from './util/utils';
import AdditionalProducts from './pages/additional-products/AdditionalProducts';
import Receipt from './pages/receipt/Receipt';
import ErrorPage from './pages/error-page/ErrorPage';

if (!DEBUG) {
  Sentry.init({
    dsn: 'https://048bf0afc10647e291221880c967245a@o47373.ingest.sentry.io/5638989',
    release: __COMMIT_HASH__
  });
}
const App = () => {
  useAuthenticate();
  enableTabKeyDetection();

  return (
    <AppContainer>
      <GlobalMenu />
      <AllIcons />
      <Main>
        <StepIndicatorBar />
        <Switch>
          <Route path={routes.personalia} component={Personalia} />
          <Route path={routes.prices} component={SalesPackagePage} />
          <Route path={routes.additionalProducts} component={AdditionalProducts} />
          <Route path={routes.receipt} component={Receipt} />
          <Route path={'/feil'} component={ErrorPage} />
          <Route component={AddressSearch} />
        </Switch>
      </Main>
    </AppContainer>
  );
};

export default App;

const AppContainer = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const Main = styled('main')({
  minHeight: `calc(100vh - ${headerHeight}px)`,
  padding: `4.8rem 0`,
  [MediaQueries.medium]: {
    padding: paddingMedium
  },
  [MediaQueries.onlyMobile]: {
    padding: paddingSmall
  }
});
